import { ReactComponent as TreeViewFullScreen } from "./svg/icon-tree-view-full-screen.svg";

export const IconTreeViewFullScreen = () => <TreeViewFullScreen />;
